import { useMemo } from 'react';
import { Autocomplete } from 'src/components/Autocomplete';
import { Chip } from 'src/components/Chip';
import { TextField } from 'src/components/TextField';
import { useSession } from 'src/contexts/SessionContext';

interface ProductTagFilterProps {
  field: string;
  label: string;
  value: string[] | undefined;
  setValue: (newVal: string[]) => void;
  valueOnly?: boolean;
}

export const ProductTagFilter: React.FC<ProductTagFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedValues = value || [];

  const { session } = useSession();

  const options = useMemo(
    () => session?.productTags || [],
    [session?.productTags]
  );

  if (valueOnly) {
    return selectedValues.length > 0 ? <>{selectedValues.join(', ')}</> : null;
  }

  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(option) => option}
      value={selectedValues}
      onChange={(_, newValue) => setValue(newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={!selectedValues.length ? 'Any' : ''}
        />
      )}
      renderTags={(value: readonly string[], getTagProps) =>
        value.map((option: string, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });
          return <Chip label={option} key={key} {...tagProps} />;
        })
      }
    />
  );
};
